import styled from 'styled-components'

export const StyledMyPageWelcome = styled.div`
  padding: 15px;

  a {
    font-size: 14px;
  }
`
